<mat-chip-list>
  <mat-chip [disableRipple]="true" class="application-complete-status-pill" *ngIf="applicationComplete" [matTooltip]="appCompleteTooltip" matTooltipPosition="above">App Complete</mat-chip>
</mat-chip-list>
